import {
    GET_PENDING_POD_REGION_STATE_REPORT_ERROR,
    GET_PENDING_POD_REGION_STATE_REPORT_REQUEST,
    GET_PENDING_POD_REGION_STATE_REPORT_SUCCESS,
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getPendingPODStateReport = (token, selected_id, data) => (dispatch) => {


    dispatch({ type: GET_PENDING_POD_REGION_STATE_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getSalePodOmsStateReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: moment(data.from_date).format("MM-DD-YYYY"),
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            customer_type_id: data.customer_type_id === "All" ? null : data.customer_type_id,
            region_id: selected_id,
            company_id: data.company_id === "All" ? null : data.company_id
        }
    })
        .then((response) => {
            return dispatch({ type: GET_PENDING_POD_REGION_STATE_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_PENDING_POD_REGION_STATE_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_PENDING_POD_REGION_STATE_REPORT_ERROR,
                payload: error.response,
            });
        });
};
